(() => {
  const STORAGE_KEY = 'protactic:gear-mission:v2';
  const LEGACY_STORAGE_KEYS = ['protactic:gear-mission:v1'];

  const init = () => {
    const hero = document.querySelector('[data-gm-hero]');
    const wizard = document.querySelector('[data-gm-wizard]');
    if (!hero || !wizard || wizard.dataset.gmReady === 'true') return;
    wizard.dataset.gmReady = 'true';

    const tiers = [
      Math.max(0, Number(hero.dataset.tierOne) || 10),
      Math.max(0, Number(hero.dataset.tierTwo) || 15),
      Math.max(0, Number(hero.dataset.tierThree) || 20)
    ];
    const defaultCapabilities = (wizard.dataset.defaultCapabilities || 'medical,utility').split(',').map((value) => value.trim()).filter(Boolean);
    const allowedStarts = ['omega', 'existing'];
    const allowedCarry = ['long', 'short', 'both', 'none'];
    const allowedCapabilities = ['communication', 'medical', 'utility', 'organization', 'unsure'];
    const allowedMobility = ['mobility', 'transport', 'none'];
    const emptyState = () => ({ started: false, step: 1, start: '', carry: '', capabilities: [], mobility: '', products: {} });
    const sanitizeState = (stored) => {
      const next = emptyState();
      if (!stored || typeof stored !== 'object' || stored.started !== true) return next;
      next.started = true;
      next.start = allowedStarts.includes(stored.start) ? stored.start : '';
      next.carry = allowedCarry.includes(stored.carry) ? stored.carry : '';
      next.capabilities = Array.isArray(stored.capabilities) ? [...new Set(stored.capabilities.filter((value) => allowedCapabilities.includes(value)))] : [];
      if (next.capabilities.includes('unsure')) next.capabilities = ['unsure'];
      next.mobility = allowedMobility.includes(stored.mobility) ? stored.mobility : '';
      next.products = stored.products && typeof stored.products === 'object' ? stored.products : {};

      let furthestStep = 1;
      if (next.start) furthestStep = 2;
      if (next.start && next.carry) furthestStep = 3;
      if (next.start && next.carry && next.capabilities.length) furthestStep = 4;
      const complete = next.start && next.carry && next.capabilities.length && next.mobility;
      if (stored.step === 'result' && complete) next.step = 'result';
      else next.step = Math.max(1, Math.min(Number(stored.step) || furthestStep, furthestStep));
      return next;
    };
    let state = emptyState();
    let adding = false;

    try {
      state = sanitizeState(JSON.parse(sessionStorage.getItem(STORAGE_KEY)));
      LEGACY_STORAGE_KEYS.forEach((key) => sessionStorage.removeItem(key));
    } catch (_) {}

    const nodes = {
      panels: [...wizard.querySelectorAll('[data-gm-panel]')],
      back: wizard.querySelector('[data-gm-back]'),
      stepLabel: wizard.querySelector('[data-gm-step-label]'),
      stepBar: wizard.querySelector('[data-gm-step-bar]'),
      benefitTitle: wizard.querySelector('[data-gm-benefit-title]'),
      benefitBar: wizard.querySelector('[data-gm-benefit-bar]'),
      benefitRate: wizard.querySelector('[data-gm-benefit-rate]'),
      resultProducts: wizard.querySelector('[data-gm-result-products]'),
      resultEmpty: wizard.querySelector('[data-gm-result-empty]'),
      resultCount: wizard.querySelector('[data-gm-result-count]'),
      subtotal: wizard.querySelector('[data-gm-subtotal]'),
      discount: wizard.querySelector('[data-gm-discount]'),
      savings: wizard.querySelector('[data-gm-savings]'),
      total: wizard.querySelector('[data-gm-total]'),
      addAll: wizard.querySelector('[data-gm-add-all]'),
      cartStatus: wizard.querySelector('[data-gm-cart-status]'),
      entryModal: hero.querySelector('[data-gm-entry-modal]'),
      entryContinue: hero.querySelector('[data-gm-entry-continue]'),
      entryContinueText: hero.querySelector('[data-gm-entry-continue-text]')
    };
    const startButton = hero.querySelector('[data-gm-start]');
    const startButtons = [...document.querySelectorAll('[data-gm-start]')];
    const initialStartLabel = startButton?.textContent.trim() || 'COMENZAR CONFIGURACIÓN';
    const addAllLabel = nodes.addAll?.textContent.trim() || 'AGREGAR TODO AL CARRITO';
    wizard.querySelectorAll('[data-gm-heroes-bonus]').forEach((node) => { node.textContent = hero.dataset.heroesBonus || '10'; });

    const money = (cents) => `$${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(cents || 0) / 100)}`;
    const discountForCount = (count) => count >= 3 ? tiers[2] : count === 2 ? tiers[1] : count === 1 ? tiers[0] : 0;
    const save = () => {
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (_) {}
    };
    const hasCompleteAnswers = () => Boolean(state.start && state.carry && state.capabilities.length && state.mobility);
    const hasProgress = () => Boolean(state.started && (state.start || state.carry || state.capabilities.length || state.mobility));
    const updateEntryModal = () => {
      const canContinue = hasProgress();
      if (nodes.entryContinue) nodes.entryContinue.disabled = !canContinue;
      if (!nodes.entryContinueText) return;
      if (!canContinue) nodes.entryContinueText.textContent = 'No hay una configuración en progreso.';
      else if (state.step === 'result' && hasCompleteAnswers()) nodes.entryContinueText.textContent = 'Volver a tu configuración terminada.';
      else nodes.entryContinueText.textContent = `Retomar desde el paso ${Math.max(1, Number(state.step) || 1)}.`;
    };
    const updateStartButton = () => {
      if (!startButton) return;
      if (!state.started) startButton.textContent = initialStartLabel;
      else if (state.step === 'result' && hasCompleteAnswers()) startButton.textContent = 'VER MI CONFIGURACIÓN';
      else startButton.textContent = 'CONTINUAR CONFIGURACIÓN';
      updateEntryModal();
    };
    const emit = (event, detail = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, campaign: 'configura-tu-mision', ...detail });
    };
    const setCartStatus = (message, type = '') => {
      if (!nodes.cartStatus) return;
      nodes.cartStatus.textContent = message;
      nodes.cartStatus.className = `gm-summary__status${type ? ` is-${type}` : ''}`;
    };

    const categoriesFromAnswers = () => {
      const categories = [];
      if (state.start === 'omega') categories.push('platform');
      if (state.carry === 'long' || state.carry === 'both') categories.push('long');
      if (state.carry === 'short' || state.carry === 'both') categories.push('short');
      const capabilities = state.capabilities.includes('unsure') ? defaultCapabilities : state.capabilities;
      categories.push(...capabilities);
      if (state.mobility && state.mobility !== 'none') categories.push(state.mobility);
      return [...new Set(categories.filter(Boolean))];
    };

    const candidatesFor = (category) => {
      const source = wizard.querySelector(`[data-gm-product-source][data-category="${category}"]`);
      if (!source) return [];
      const seen = new Set();
      return [...source.querySelectorAll('template[data-gm-product-template]')].filter((template) => {
        const id = template.dataset.productId;
        if (!id || seen.has(id)) return false;
        seen.add(id);
        return true;
      });
    };

    const anticipatedCount = () => categoriesFromAnswers().length;
    const selectedCards = () => [...nodes.resultProducts.querySelectorAll('[data-gm-result-product]')];

    const updateBenefit = (count = anticipatedCount()) => {
      const rate = discountForCount(count);
      let title = 'Comienza tu configuración';
      let width = 0;
      if (count === 1) { title = `1 producto · ${rate}% OFF`; width = 34; }
      if (count === 2) { title = `2 productos · ${rate}% OFF`; width = 67; }
      if (count >= 3) { title = `Has desbloqueado ${rate}% OFF`; width = 100; }
      nodes.benefitTitle.textContent = title;
      nodes.benefitRate.textContent = `${rate}%`;
      nodes.benefitBar.style.width = `${width}%`;
    };

    const syncAnswers = () => {
      wizard.querySelectorAll('[data-gm-answer]').forEach((button) => {
        const step = button.dataset.step;
        const value = button.dataset.value;
        const selected = step === '1' ? state.start === value : step === '2' ? state.carry === value : step === '3' ? state.capabilities.includes(value) : state.mobility === value;
        button.setAttribute('aria-pressed', String(selected));
      });
      const capabilityContinue = wizard.querySelector('[data-gm-continue="3"]');
      if (capabilityContinue) capabilityContinue.disabled = state.capabilities.length === 0;
      const resultButton = wizard.querySelector('[data-gm-show-result]');
      if (resultButton) resultButton.disabled = !state.mobility;
    };

    const showPanel = (panelName, focus = true) => {
      const isResult = panelName === 'result';
      wizard.classList.toggle('has-result', isResult);
      nodes.panels.forEach((panel) => {
        const active = panel.dataset.gmPanel === String(panelName);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      nodes.back.hidden = panelName === 1;
      nodes.stepLabel.textContent = isResult ? 'CONFIGURACIÓN LISTA' : `PASO ${panelName} DE 4`;
      nodes.stepBar.style.width = isResult ? '100%' : `${Number(panelName) * 25}%`;
      state.step = panelName;
      save();
      updateStartButton();
      if (focus) requestAnimationFrame(() => wizard.querySelector(`[data-gm-panel="${panelName}"] button, [data-gm-panel="${panelName}"] select`)?.focus({ preventScroll: true }));
    };

    const openWizard = (panel = state.step || 1) => {
      state.started = true;
      wizard.hidden = false;
      syncAnswers();
      showPanel(panel === 'result' && !hasCompleteAnswers() ? 1 : panel, false);
      wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      emit('mission_configurator_started');
    };
    const closeWizard = () => {
      wizard.hidden = true;
      hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const closeEntryModal = () => {
      if (!nodes.entryModal) return;
      if (typeof nodes.entryModal.close === 'function' && nodes.entryModal.open) nodes.entryModal.close();
      else nodes.entryModal.removeAttribute('open');
    };
    const openEntryModal = () => {
      if (!nodes.entryModal || nodes.entryModal.open) return;
      updateEntryModal();
      if (typeof nodes.entryModal.showModal === 'function') nodes.entryModal.showModal();
      else nodes.entryModal.setAttribute('open', '');
    };
    const restartConfiguration = () => {
      state = emptyState();
      state.started = true;
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
      nodes.resultProducts.innerHTML = '';
      setCartStatus('');
      syncAnswers();
      updateBenefit(0);
      updateStartButton();
      wizard.hidden = false;
      showPanel(1, false);
      wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      emit('mission_configuration_restarted');
    };

    const variantData = (card) => {
      const control = card.querySelector('[data-gm-variant]');
      if (!control) return null;
      const option = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
      return { id: Number(control.value), price: Number(option.dataset.price || 0), image: option.dataset.image || '' };
    };

    const persistCard = (card) => {
      const variant = variantData(card);
      state.products[card.dataset.category] = { index: Number(card.dataset.sourceIndex || 0), variantId: variant?.id || 0, removed: false };
      save();
    };

    const hydrateCard = (card, category, index) => {
      card.dataset.category = category;
      card.dataset.sourceIndex = String(index);
      const stored = state.products[category];
      const control = card.querySelector('[data-gm-variant]');
      if (stored?.variantId && control?.querySelector?.(`option[value="${stored.variantId}"]`)) control.value = String(stored.variantId);
      const updateVariant = () => {
        const data = variantData(card);
        if (!data) return;
        card.querySelector('[data-gm-product-price]').textContent = money(data.price);
        if (data.image) {
          const image = card.querySelector('.gm-result-product__image');
          if (image) { image.removeAttribute('srcset'); image.src = data.image; }
        }
        persistCard(card);
        updateSummary();
      };
      if (control?.tagName === 'SELECT') control.addEventListener('change', updateVariant);
      card.querySelector('[data-gm-change-product]')?.addEventListener('click', () => {
        const candidates = candidatesFor(category);
        if (candidates.length < 2) { setCartStatus('No hay productos alternativos configurados para esta función.', 'error'); return; }
        const occupied = new Set(selectedCards().filter((item) => item !== card).map((item) => item.dataset.productId));
        let nextIndex = index;
        for (let offset = 1; offset <= candidates.length; offset += 1) {
          const candidateIndex = (index + offset) % candidates.length;
          if (!occupied.has(candidates[candidateIndex].dataset.productId)) { nextIndex = candidateIndex; break; }
        }
        if (nextIndex === index) { setCartStatus('No hay otra alternativa disponible para esta función.', 'error'); return; }
        const nextCard = candidates[nextIndex].content.firstElementChild.cloneNode(true);
        state.products[category] = { index: nextIndex, variantId: 0, removed: false };
        hydrateCard(nextCard, category, nextIndex);
        card.replaceWith(nextCard);
        save();
        updateSummary();
      });
      card.querySelector('[data-gm-remove-product]')?.addEventListener('click', () => {
        state.products[category] = { ...(state.products[category] || {}), removed: true };
        card.remove();
        save();
        updateSummary();
      });
      updateVariant();
    };

    const updateSummary = () => {
      const cards = selectedCards();
      const unique = new Map();
      cards.forEach((card) => {
        const data = variantData(card);
        if (data?.id && !unique.has(data.id)) unique.set(data.id, data);
      });
      const items = [...unique.values()];
      const count = items.length;
      const subtotal = items.reduce((sum, item) => sum + item.price, 0);
      const rate = discountForCount(count);
      const savings = Math.floor(subtotal * rate / 100);
      nodes.resultCount.textContent = `${count} ${count === 1 ? 'PRODUCTO' : 'PRODUCTOS'}`;
      nodes.subtotal.textContent = money(subtotal);
      nodes.discount.textContent = `${rate}% OFF`;
      nodes.savings.textContent = `−${money(savings)}`;
      nodes.total.textContent = money(subtotal - savings);
      nodes.addAll.disabled = count === 0 || adding;
      nodes.resultEmpty.hidden = count > 0;
      updateBenefit(count);
    };

    const renderResult = () => {
      if (!hasCompleteAnswers()) {
        restartConfiguration();
        return;
      }
      nodes.resultProducts.innerHTML = '';
      const usedProducts = new Set();
      categoriesFromAnswers().forEach((category) => {
        const candidates = candidatesFor(category);
        if (!candidates.length || state.products[category]?.removed) return;
        let index = Math.min(Number(state.products[category]?.index || 0), candidates.length - 1);
        if (usedProducts.has(candidates[index].dataset.productId)) {
          const unusedIndex = candidates.findIndex((candidate) => !usedProducts.has(candidate.dataset.productId));
          if (unusedIndex < 0) return;
          index = unusedIndex;
        }
        usedProducts.add(candidates[index].dataset.productId);
        const card = candidates[index].content.firstElementChild.cloneNode(true);
        hydrateCard(card, category, index);
        nodes.resultProducts.appendChild(card);
      });
      showPanel('result', false);
      updateSummary();
      emit('mission_configuration_viewed', { recommended_categories: categoriesFromAnswers().join(',') });
    };

    startButtons.forEach((button) => button.addEventListener('click', () => {
      if (state.step === 'result' && hasCompleteAnswers()) {
        wizard.hidden = false;
        renderResult();
        wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else openWizard(state.step);
    }));
    wizard.querySelector('[data-gm-close]')?.addEventListener('click', closeWizard);
    nodes.back.addEventListener('click', () => {
      if (state.step === 'result') showPanel(4);
      else showPanel(Math.max(1, Number(state.step) - 1));
    });

    wizard.addEventListener('click', (event) => {
      const answer = event.target.closest('[data-gm-answer]');
      if (!answer) return;
      const step = answer.dataset.step;
      const value = answer.dataset.value;
      if (step === '1') { state.start = value; state.products = {}; syncAnswers(); save(); updateBenefit(); showPanel(2); }
      else if (step === '2') { state.carry = value; state.products = {}; syncAnswers(); save(); updateBenefit(); showPanel(3); }
      else if (step === '3') {
        if (value === 'unsure') state.capabilities = state.capabilities.includes('unsure') ? [] : ['unsure'];
        else {
          state.capabilities = state.capabilities.filter((item) => item !== 'unsure');
          state.capabilities = state.capabilities.includes(value) ? state.capabilities.filter((item) => item !== value) : [...state.capabilities, value];
        }
        state.products = {};
        syncAnswers(); save(); updateBenefit();
      } else if (step === '4') { state.mobility = value; state.products = {}; syncAnswers(); save(); updateBenefit(); }
    });

    wizard.querySelector('[data-gm-continue="3"]')?.addEventListener('click', () => showPanel(4));
    wizard.querySelector('[data-gm-show-result]')?.addEventListener('click', renderResult);
    wizard.querySelector('[data-gm-edit-answers]')?.addEventListener('click', () => showPanel(1));
    wizard.querySelector('[data-gm-restart]')?.addEventListener('click', restartConfiguration);
    hero.querySelector('[data-gm-entry-close]')?.addEventListener('click', closeEntryModal);
    hero.querySelector('[data-gm-entry-start]')?.addEventListener('click', () => {
      closeEntryModal();
      restartConfiguration();
    });
    nodes.entryContinue?.addEventListener('click', () => {
      if (!hasProgress()) return;
      closeEntryModal();
      if (state.step === 'result' && hasCompleteAnswers()) {
        wizard.hidden = false;
        renderResult();
        wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else openWizard(state.step);
      emit('mission_entry_selected', { route: 'continue' });
    });
    hero.querySelector('[data-gm-entry-suggested]')?.addEventListener('click', () => {
      closeEntryModal();
      document.querySelector('[data-gm-routes]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      emit('mission_entry_selected', { route: 'suggested' });
    });
    nodes.entryModal?.addEventListener('click', (event) => {
      if (event.target === nodes.entryModal) closeEntryModal();
    });

    document.querySelectorAll('[data-gm-route]').forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.destination === 'favorites') {
        document.querySelector('[data-gm-favorites]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        emit('mission_quick_route_selected', { route: 'catalogo-gear' });
        return;
      }
      state = {
        ...emptyState(),
        started: true,
        start: button.dataset.start || 'existing',
        carry: button.dataset.carry || 'none',
        capabilities: (button.dataset.capabilities || '').split(',').map((value) => value.trim()).filter(Boolean),
        mobility: button.dataset.mobility || 'none'
      };
      save();
      wizard.hidden = false;
      syncAnswers();
      renderResult();
      wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      emit('mission_quick_route_selected', { route: button.closest('.gm-route')?.querySelector('h3')?.textContent.trim() || '' });
    }));

    nodes.addAll.addEventListener('click', async () => {
      if (adding) return;
      const variants = new Map();
      selectedCards().forEach((card) => {
        const data = variantData(card);
        if (data?.id) variants.set(data.id, data);
      });
      if (!variants.size) return;
      adding = true;
      nodes.addAll.disabled = true;
      nodes.addAll.textContent = 'AGREGANDO…';
      setCartStatus('Agregando tu configuración…');
      const shopRoot = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [...variants.keys()].map((id) => ({ id, quantity: 1, properties: { _campaign: 'configura-tu-mision', _mission_configuration: 'true' } })) })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'No fue posible agregar la configuración.');
        const cartResponse = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        if (!cartResponse.ok) throw new Error('La configuración se agregó, pero no fue posible actualizar el carrito.');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'gear-mission' } }));
        setCartStatus('Configuración agregada al carrito.', 'success');
        emit('mission_configuration_added_to_cart', { item_count: variants.size, discount_tier: discountForCount(variants.size) });
        const cartLink = document.querySelector('[data-cart-link]');
        if (cartLink) cartLink.click();
        else window.location.href = `${shopRoot}cart`;
      } catch (error) {
        setCartStatus(error.message, 'error');
      } finally {
        adding = false;
        nodes.addAll.textContent = addAllLabel;
        updateSummary();
      }
    });

    syncAnswers();
    updateBenefit();
    updateStartButton();
    requestAnimationFrame(openEntryModal);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
